/**
 * Format error code with optional status code for display
 * @param errorCode - The error code (e.g., "API_CASE_GET")
 * @param status - Optional HTTP status code (e.g., 404, 500)
 * @returns Formatted error code string (e.g., "API_CASE_GET_404" or "API_CASE_GET")
 */
export function formatErrorCode(errorCode?: string, status?: number): string | undefined {
  if (!errorCode) {
    return undefined;
  }

  // If status is provided and valid, append it to the error code
  if (status !== undefined && !isNaN(status) && status > 0) {
    return `${errorCode}_${status}`;
  }

  // Return just the error code if no valid status
  return errorCode;
}

/**
 * Format error code with label for display in UI
 * @param errorString - The formatted error code (e.g., "API_CASE_GET_404")
 * @returns Formatted string with label (e.g., "Error Code: API_CASE_GET_404")
 */
export function formatErrorCodeWithLabel(errorString?: string): string | undefined {
  if (!errorString) {
    return undefined;
  }

  return `Error Code: ${errorString}`;
}
